// TODO: For the time being this code will be commented until the endpoint is completed by gaming area (AOCC-6466).
import { Injectable } from "@angular/core";
import { Quicklink } from "@obg/ngx.core.content";
// import { CoreHttpClient } from "@obg/ngx.core";
import { BehaviorSubject, Observable, of, Subscription } from "rxjs";
import { take, tap } from "rxjs/operators";

import { SB_POPULAR_CATEGORY_RESPONSE } from "../../testing";

// import { SBPopularCategoriesConfigService } from "./sb-popular-categories.config";
import { SBCategory, SBPopularCategoriesResponse } from "./sb-popular-categories.model";

@Injectable({
	providedIn: "root",
})
export class SBPopularCategoriesService {
	allSportsbookCategories$$: Subscription | undefined;

	// constructor(
	// private httpClient: CoreHttpClient,
	// private config: SBPopularCategoriesConfigService
	// ) {
	// }

	getAllPopularCategories(): Observable<SBPopularCategoriesResponse> {
		return of(SB_POPULAR_CATEGORY_RESPONSE);
		/* return this.httpClient.get<SBPopularCategoriesResponse>({
			  url: this.config.getSBPopularCategoriesEndpoint(#AOCC-6466)
		}); */
	}

	transformToQuickLinks$$(
		sbCategories: SBCategory[],
		allSportsbookCategories: Observable<Quicklink[]>
	): BehaviorSubject<Quicklink[]> {
		const popularQuickLinks$$ = new BehaviorSubject<Quicklink[]>([]);
		this.allSportsbookCategories$$ = allSportsbookCategories
			.pipe(
				take(1),
				tap((allCategories) => {
					const sortedSBCategories = this.sortSBCategoriesByPopularity(sbCategories);
					const popularQuickLinks: Quicklink[] = [];
					for (const category of sortedSBCategories) {
						const popularQuickLink = allCategories.find(
							(crsCategory) => crsCategory.documentKey.split(".")[1] === category.trackingLabel
						);
						if (popularQuickLink) {
							popularQuickLinks.push(popularQuickLink);
						}
					}
					popularQuickLinks$$.next(popularQuickLinks);
				})
			)
			.subscribe();
		return popularQuickLinks$$;
	}

	private sortSBCategoriesByPopularity(sbCategories: SBCategory[]) {
		return sbCategories.sort((c1, c2) => {
			if (c1.popularityOrder <= c2.popularityOrder) {
				return 1;
			}
			return -1;
		});
	}
}
